import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/lib/integration/react';
import { signalRStart } from './middlewares/Kiosk-Middleware';
import { ConnectedRouter } from 'connected-react-router'
import { WSStart, PlacesWSStart } from './middlewares/WebSocket-Middleware';
import { InternetListeners } from './middlewares/InternetConnect';
import { initTokenActions } from './middlewares/Initialization';

import { store, history } from './helpers/store';

// Import moment spanish
import 'moment/locale/es-us';

initTokenActions(store);                     // initializion token needed methods
InternetListeners(store);                   // Add listeners for internet connection

signalRStart(store);
WSStart(store);
PlacesWSStart(store);

const persistor = persistStore(store)

ReactDOM.render((
  <Provider store={store}>
    <PersistGate
      persistor={persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>
), document.getElementById('root'));